
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_ptw8i_c6ghi_9",
  "hovered": "awsui_hovered_ptw8i_c6ghi_22",
  "content": "awsui_content_ptw8i_c6ghi_29"
};
  